import Vue from 'vue';

Vue.filter('datetime', function (value, type) {
  if(!value) return ''
  const newDate = new Date(value.slice(0, 19).replace(/-/g, '/'));
  if (!newDate) return '';
  const strYear = newDate.getFullYear();
  const strMonth = (newDate.getMonth() + 1).toString().padStart(2, '0');
  const strDate = (newDate.getDate()).toString().padStart(2, '0');
  switch (type) {
    case 'date':
      return `${strYear}/${strMonth}/${strDate}`
    default:
      return ''
  }
})